import { MarkDoneButton } from "@/modules/calling/leads-carousel/v2/actions/basic-buttons/mark-done-button";

export const ActionsBeforeCall = () => (
  <div className="[&>*]:w-full">
    <MarkDoneButton withEmail className="w-full" />
  </div>
);
